import { takeEvery, takeLeading } from 'redux-saga/effects';

import { coreActions } from 'app-components/flux/core-actions';
import { featureFlagsActions } from 'app-components/flux/feature-flags';
import { coreSettings, localPreferences, loggerConfigurator } from 'app-components/utils/core';

import { initializeFeatureFlags } from 'utils/featureFlags/initialize';

function* updateChangedFeatureFlagsActionWatcher() {
  yield takeEvery(
    featureFlagsActions.applyFeatureFlagsChanges,
    function* applyFeatureFlagsChanges({ payload: flags, meta }) {
      if (meta?.context !== 'init') {
        const { persist } = flags;
        if (persist != null) {
          localPreferences.setPersist(persist);
        }

        const { debug } = flags;
        if (debug != null) {
          localPreferences.setDebug(debug);
        }

        const { persistPurgeVersion } = flags;
        if (persistPurgeVersion != null) {
          localPreferences.setPersistPurgeVersion(persistPurgeVersion);
        }

        const { loggingLevel } = flags;
        if (loggingLevel != null) {
          loggerConfigurator.setFeatureFlagLoggingLevel(loggingLevel);
        }

        const { fetchDebounce } = flags;
        if (fetchDebounce != null) {
          coreSettings.fetchDebounceTimeout = fetchDebounce;
        }
      }
    },
  );
}

function* persistDataLoadCompleteActionWatcher() {
  yield takeLeading(coreActions.persistDataLoadComplete, function* persistDataLoadComplete() {
    initializeFeatureFlags();
  });
}

export default [updateChangedFeatureFlagsActionWatcher, persistDataLoadCompleteActionWatcher];
